<template>
  <vs-popup
    :active.sync="isModalActive"
    @close="closeModal"
    :title="title"
    id="prompt-modal"
  >
    <div class="flex items-center justify-start gap-3">
      <vs-icon
        :icon-pack="iconPack"
        :icon="icon"
        :color="iconColor"
        :size="iconSize"
      />
      <span class="text-sm">{{ message }}</span>
    </div>
    <div class="flex items-center gap-6 justify-end mt-6">
      <vs-button
        @click="closeModal(false)"
        type="border"
        :color="iconColor"
        class="py-3 px-6"
        >Cancelar</vs-button
      >
      <vs-button @click="closeModal(true)" color="success">Confirmar</vs-button>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'GenericPromptModal',

  props: {
    title: {
      type: String,
      default: 'Nome do Modal',
    },
    iconPack: {
      type: String,
    },
    icon: {
      type: String,
      default: 'icon-more-horizontal',
    },
    iconColor: {
      type: String,
      default: '#000',
    },
    iconSize: {
      type: String,
      default: '1.5rem',
    },
    message: {
      type: String,
      default: 'Tem certeza?',
    },
  },

  data() {
    return {
      isModalActive: false,
    };
  },

  methods: {
    async showModal() {
      this.isModalActive = true;
    },
    async closeModal(confirmed) {
      this.isModalActive = false;
      this.$emit('confirmed', confirmed);
    },
  },
};
</script>

<style lang="css">
#prompt-modal .vs-popup {
  max-width: 30rem;
}
#prompt-modal .vs-popup--content {
  padding: 1rem 2rem 2rem 2rem;
}
</style>
